import * as React from "react";
import Header from "./header";
import Footer from "./footer";
type MainLayoutType = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: MainLayoutType) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}
